module.exports = "<searchTool *ngIf=\"isLoggedIn\"></searchTool>\n"